import { render, staticRenderFns } from "./FAQCreate.vue?vue&type=template&id=5b2415f7&scoped=true&"
import script from "./FAQCreate.vue?vue&type=script&lang=js&"
export * from "./FAQCreate.vue?vue&type=script&lang=js&"
import style0 from "./FAQCreate.vue?vue&type=style&index=0&id=5b2415f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2415f7",
  null
  
)

export default component.exports